import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import router from "@/router";
import {
  db,
  usersCollection,
  gamesCollection,
  currentCollection,
  init_items,
  route_path
} from "@/main";
import { admin } from "./modules/admin";
import { auth } from "./modules/auth";
import { listeners } from "./modules/listeners";
// import { game } from "./modules/game";
// import { appAuthauth } from "./modules/appAuth";

Vue.use(Vuex);

const deepCopyFunction = inObject => {
  let outObject, value, key;

  if (typeof inObject !== "object" || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCopyFunction(value);
  }

  return outObject;
};

// initial state
// let initialState = {
//  state: state,
//  auth: auth.state,
//  admin: admin.state
// };
export default new Vuex.Store({
  state: {
    projects: [],
    games: [],
    allResults: [],
    groupPlay: false,
    currentGame: { open: false, step: 8 },
    results: {},
    gameUID: null
  },
  mutations: {
    // reset (state) {
    //   Object.keys(state).forEach(key => {
    //     Object.assign(state[key], initialState[key])
    //   })
    // },
    setGameUID(state, id) {
      state.gameUID = id;
    },
    setCurrentGame(state, payload) {
      state.currentGame = payload;
    },
    // addGame(state, payload) {
    //   state.games.push(payload);
    // },
    // modifyGame(state, payload) {
    //   // console.log("modifyGame :"+payload.id);
    //   const index = state.games.findIndex(item => item.id === payload.id);

    //   // console.log("Index:  "+index.toString());
    //   Vue.set(state.games, index, payload);
    // },

    addResult(state, result) {
      const index = state.allResults.findIndex(
        item => item.resultID == result.resultID
      );
      console.log("Index AddResult: ",index);
      state.allResults.push(result);
    },

    modifyResult(state, result) {
      const index = state.allResults.findIndex(
        item => item.resultID == result.resultID
      );
      console.log("Index Modify Result: ",index);
      // const index = state.allResults.findIndex(
      //   item => item.resultID == result.resultID
      // );
      Vue.set(state.allResults, index, result);
    },
    clearAllResults(state) {
      state.allResults = [];
    },
    // clearGames(state) {
    //   state.games = [];
    // },
    resetProjects(state) {
      let deepCopied = deepCopyFunction(init_items);
      Object.assign(state.projects, deepCopied);
    },
    updateProject(state, payload) {
      const idx = payload.id;
      state.projects[idx].result = payload.result;
    },

    setGroupPlay(state, payload) {
      state.groupPlay = payload;
    },

    setFunded(state, selection) {
      const index = state.projects.findIndex(item => item.id === selection.id);
      selection.funded = true;
      Vue.set(state.projects, index, selection);
    },
    setUnfunded(state, selection) {
      const index = state.projects.findIndex(item => item.id === selection.id);
      selection.funded = false;
      Vue.set(state.projects, index, selection);
    },

    updateProject(state, id, updates) {
      let project = state.projects.find(obj => obj.id === id);
      project.result = updates.result;
      project.value = updates.value;
      project.prob_value = updates.prob_value;
      project.points = updates.points;
      project.rolled = updates.rolled;
    },

    updateRoll(state, selection) {
      const index = state.projects.findIndex(item => item.id === selection.id);
      if (index !== -1) {
        Vue.set(state.projects, index, selection);
      }
    },
    setResults(state, payload) {
      // console.log("setResults:  ",payload);
      Object.assign(state.results, payload);
    },

    clearResults(state) {
      state.results = {};
    }
  },
  actions: {
    async savePortfolio({ state }) {
      // dispatch("tabulateResults");
      await usersCollection.doc(state.auth.user).update({
        projects: state.projects
      });
    },

    gameStart({ state }) {
      usersCollection.doc(state.auth.user).update({
        gameStart: firebase.firestore.FieldValue.serverTimestamp()
      });
    },

    addDisplayName(name) {
      var user = firebase.auth().currentUser;
      user
        .updateProfile({
          displayName: name
        })
        .then(function() {
          // Update successful.
          // alert("Success DisplayName");
        })
        .catch(function(error) {
          // An error happened.
          // alert("Error in addDisplayName");
        });
    },

    chooseFunded({ commit, state }, item) {
      let funded = state.projects.filter(obj => obj.funded === true);
      if (funded.length < 5) {
        commit("setFunded", item);
      }
    },
    removeFunded({ commit }, item) {
      this.commit("setUnfunded", item);
    },

    async groupPlay({ commit, rootGetters, getters }, flag) {
      // alert("groupPlay");
      commit("setGroupPlay", flag);
      if (flag) {
        const user = firebase.auth().currentUser.uid;
        // alert("groupPlay true "+user);
        await currentCollection.doc("game").update({
          players: firebase.firestore.FieldValue.arrayUnion(user)
        });
        // await gamesCollection.doc(rootGetters.currentGame.id).update({
        //   players: firebase.firestore.FieldValue.arrayUnion(getters.user)
        // });
      } else {
        // alert("groupPlay false");
      }
      // dispatch("tabulateResults");
    },

    async startNewGame() {
      const startTime = firebase.firestore.FieldValue.serverTimestamp();
      const res = await gamesCollection.add({
        timestamp: startTime,
        open: true
      });
      await currentCollection.doc("game").set({
        timestamp: startTime,
        open: true,
        id: res.id,
        step: 1
      });
    },

    async updateGameStep({ state }, step) {
      await currentCollection.doc("game").update({
        step: step
      });
    },

    async endGame() {
      const current = await currentCollection.doc("game").get();
      // console.log("endgame", current.data());
      await currentCollection.doc("game").set({
        open: false,
        step: 8
      });
      if (current.data().players !== undefined) {
        await gamesCollection.doc(current.data().id).set({
          timestamp: current.data().timestamp,
          finished: firebase.firestore.FieldValue.serverTimestamp(),
          players: current.data().players
        });
      } else {
        await gamesCollection.doc(current.data().id).delete();
      }
    },

    async getCurrentGame() {
      const res = await gamesCollection.orderBy("timestamp", "desc").get();
      res.forEach(function(doc) {
        const t = doc.data().timestamp;
      });
    },

    // addGames({ commit }, game) {
    //   commit("addGame", game);
    // },

    // modifyGames({ commit }, game) {
    //   commit("modifyGame", game);
    // },

    addResults({ commit }, result) {
      commit("addResult", result);
    },
    modifyResults({ commit }, result) {
      commit("modifyResult", result);
    },

    tabulateResults({ state, commit, getters }) {
      const projects = getters.projects;
      const funded = projects.filter(obj => obj.funded === true);
      const unfunded = projects.filter(obj => obj.funded === false);
      let gameID = "";
      if (getters.groupPlay) {
        gameID = getters.currentGame.id;
      } else {
        gameID = "individual0000000000";
      }

      let pearls = null;
      let oysters = null;
      let breadandbutter = null;
      let whiteelephant = null;
      if (funded.length === 5) {
        pearls = funded.filter(obj => obj.text === "Pearl").length;
        oysters = funded.filter(obj => obj.text === "Oyster").length;
        breadandbutter = funded.filter(obj => obj.text === "Bread and Butter").length;
        whiteelephant = funded.filter(obj => obj.text === "White Elephant")
        .length;
      }
      
      
      // const pearls = funded.filter(obj => obj.text === "Pearl").length;
      // const oysters = funded.filter(obj => obj.text === "Oyster").length;
      // const breadandbutter = funded.filter(
      //   obj => obj.text === "Bread and Butter"
      // ).length;
      // const whiteelephant = funded.filter(obj => obj.text === "White Elephant")
      //   .length;

      let fundedValue = null;
      let fundedSuccesses = null;
      let bestFiveValue = null;
      let valueOysPearl = null;
      let fundedRolled = funded.filter(obj => obj.rolled !== "").length;
      if ((funded.length >= 5) & (fundedRolled >= 5)) {
        fundedValue = funded.reduce((a, b) => a + (b["value"] || 0), 0);
        fundedSuccesses = funded.filter(obj => obj.result === "Success").length;
        const sortedValue = projects
          .sort((a, b) => {
            return b.value - a.value;
          })
          .slice(0, 5);
        bestFiveValue = sortedValue.reduce((a, b) => a + (b["value"] || 0), 0);
        // fundedRolled = funded.filter(obj => obj.rolled!=="").length;
        const bestOyPearl = sortedValue.filter(
          obj => obj.text === "Oyster" || obj.text === "Pearl"
        );
        valueOysPearl = bestOyPearl.reduce((a, b) => a + (b["value"] || 0), 0);
      }

      let unfundedValue = null;
      let unfundedSuccesses = null;
      let unfundedRolled = unfunded.filter(obj => obj.rolled !== "").length;
      if ((unfunded.length >= 5) & (unfundedRolled >= 5)) {
        unfundedValue = unfunded.reduce((a, b) => a + (b["value"] || 0), 0);
        unfundedSuccesses = unfunded.filter(obj => obj.result === "Success")
          .length;
        // unfundedRolled = unfunded.filter(obj => obj.rolled!=="").length;
      }

      // console.log("Results: ",pearls, oysters, breadandbutter,whiteelephant);
      const results = {
        id: firebase.auth().currentUser.uid,
        gameID: gameID,
        name: firebase.auth().currentUser.displayName,
        pearls: pearls,
        oysters: oysters,
        breadandbutter: breadandbutter,
        whiteelephant: whiteelephant,
        unfundedValue: unfundedValue,
        unfundedSuccesses: unfundedSuccesses,
        fundedValue: fundedValue,
        fundedSuccesses: fundedSuccesses,
        bestFiveValue: bestFiveValue,
        valueOysPearl: valueOysPearl
      };
      commit("setResults", results);
      if (state.gameUID) {
        db.collection("results")
          .doc(state.gameUID)
          .update(results);
      } else {
        results.timestamp = firebase.firestore.FieldValue.serverTimestamp();
        db.collection("results")
          .add(results)
          .then(docRef => {
            commit("setGameUID", docRef.id);
            // console.log("GameUID:  ",docRef.id);
          });
      }
    }
  },

  getters: {
    groupPlay(state) {
      return state.groupPlay;
    },

    projects(state) {
      return state.projects;
    },
    // games(state) {
    //   return state.games;
    // },
    allResults(state) {
      return state.allResults;
    },

    fundedProjects(state) {
      return state.projects.filter(obj => obj.funded === true);
    },
    unfundedProjects(state) {
      return state.projects.filter(obj => obj.funded === false);
    },
    currentGame(state) {
      return state.currentGame;
    },
    currentGameID(state) {
      if (state.currentGame.open) return state.currentGame.id;
      // return state.results.gameID;
      return null;
    },
    userCurrentGameID(state) {
      return state.results.gameID;
    },
    groupGameStep(state) {
      return state.currentGame.step;
    },
    resultID(state) {
      return state.gameUID;
    },
    advanceRoute: state => path => {
      // advanceRoute(state) {
      if (state.groupPlay) {
        const step = state.currentGame.step;
        // const routeName = router.currentRoute.path;
        const currentRouteIndex = route_path.findIndex(p => p.path == path);
        if (step > currentRouteIndex + 1) return true;
        else return false;
      } else {
        return true;
      }
    }
  },

  modules: {
    admin,
    auth,
    listeners
    // game
  }
});
